import { render, staticRenderFns } from "./motivoDeclinacionAdd.vue?vue&type=template&id=07c84492&"
import script from "./motivoDeclinacionAdd.vue?vue&type=script&lang=js&"
export * from "./motivoDeclinacionAdd.vue?vue&type=script&lang=js&"
import style0 from "./motivoDeclinacionAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports